<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.75 3.61111C10.75 3.1969 10.4142 2.86111 10 2.86111C9.58579 2.86111 9.25 3.1969 9.25 3.61111V9.25H3.61108C3.19687 9.25 2.86108 9.58579 2.86108 10C2.86108 10.4142 3.19687 10.75 3.61108 10.75H9.25V16.3889C9.25 16.8031 9.58579 17.1389 10 17.1389C10.4142 17.1389 10.75 16.8031 10.75 16.3889V10.75H16.3889C16.8031 10.75 17.1389 10.4142 17.1389 10C17.1389 9.58579 16.8031 9.25 16.3889 9.25H10.75V3.61111Z"
            fill="currentColor"
        />
    </svg>
</template>
